import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

/**
 * Custom Pagination Hook
 * @param {integer} total - Total num of items
 * @param {integer} filteredTotal - Total being shown (usually less than total)
 * @param {integer} amountPerPage - How many items are shown per page
 * @returns {array} array of items!
 */
export const usePagination = (total, filteredTotal, amountPerPage) => {
  const [currentPage, setCurrentPage] = useState(1)

  const noItems = (!total && !filteredTotal)

    /**
   * Sets index of first list item to be displayed by page.
   * currentPage = 1, Index is 0.
   * currentPage = 3, Index is 10
   */
  const reviewsIndexMin = (currentPage - 1) * amountPerPage

  const totalPages = Math.ceil(filteredTotal / amountPerPage)

  const minIndex = reviewsIndexMin + 1
  const maxIndex = (reviewsIndexMin + amountPerPage > filteredTotal)
    ? filteredTotal
    : reviewsIndexMin + amountPerPage

  useEffect(() => {
    setCurrentPage(1)
  }, [filteredTotal])

  return {
    currentPage,
    setCurrentPage,
    totalPages,
    minIndex,
    maxIndex,
    noItems
  }
}

usePagination.propTypes = {
  total: PropTypes.string.isRequired,
  filteredTotal: PropTypes.string.isRequired,
  amountPerPage: PropTypes.number.isRequired,
}